<script>

import { Overlay } from '../../'

export default {
    name: 'TypicalPrice',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'Typical Price - Average of high, low, and close',
                preset: {
                    name: 'Typical Price',
                    side: 'onchart',
                    settings: {
                        lineWidth: 1,
                        color: '#9e9e9e'
                    }
                }
            }
        },
        use_for() { return ['TypicalPrice'] },
        calc() {
            return {
                props: {},
                conf: { renderer: 'Spline' },
                update: `
                    return (high[0] + low[0] + close[0]) / 3
                `
            }
        }
    }
}
</script>
